import React from 'react';
import ServicePage from '../../components/ServicePage';

const LargeHomeMoving = () => (
  <ServicePage
    seoTitle="Large Home & Estate Moving | Navy Seals Moving"
    seoDescription="Specialists in moving large homes and estates, 4+ bedrooms, fine furniture, and valuable collections. Our own semi trucks and experienced crews handle big moves in one coordinated operation."
    headerTitle="Large Home & Estate Moving"
    introTitle="Big Homes Are Our Specialty"
    intro={[
      "Moving a large home is a different job than moving an apartment, more rooms, heavier and finer furniture, valuable and fragile items, and far more moving parts to coordinate. This is the work we've built our company around.",
      "We move large households with our own fleet of semi trucks and our own experienced crews, so a 4, 5, or 6-bedroom home moves in one coordinated operation, not split across brokers, day labor, and rented equipment. Fully licensed, bonded, and insured, with over 20 years of long-distance experience.",
      "Every large move starts with an accurate estimate by video walkthrough or an in-person visit, so the quote reflects your actual home, not a guess that grows on moving day."
    ]}
    featuresTitle="Built for Big Moves"
    features={[
      {
        icon: 'icon_house',
        title: 'Full-Home Packing',
        text: 'Complete packing service with premium materials, from wardrobe boxes and dish packs to careful wrapping for fine furniture, artwork, and fragile pieces.'
      },
      {
        icon: 'icon_group',
        title: 'Our Own Trucks & Crews',
        text: 'Dedicated semi trailers and experienced movers who work together every day. Your household is handled by one accountable team from first box to final placement.'
      },
      {
        icon: 'icon_easel',
        title: 'White-Glove Care for Valuables',
        text: 'Premium handling for the items that matter most (antiques, pianos, art, and delicate furniture), treated with the same care as our own.'
      },
      {
        icon: 'icon_datareport',
        title: 'Storage Between Homes',
        text: 'Closing dates don’t always line up. Our secure, climate-controlled warehouse bridges the gap so your household is safe until the new home is ready.'
      }
    ]}
  />
);

export default LargeHomeMoving;
